import { render, staticRenderFns } from "./emolumento.vue?vue&type=template&id=4ce4ad6f&scoped=true&"
import script from "./emolumento.vue?vue&type=script&lang=js&"
export * from "./emolumento.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ce4ad6f",
  null
  
)

export default component.exports